import { KTSVG } from "../../../../../../_metronic/helpers"
import { useDLMApplicationListView } from '../../../../core/doclabel'

const DLMApplicationTerminateModalHeader = () => {
    const {setItemIdForDelete} = useDLMApplicationListView()

    return (
    <div className='modal-header'>       
        <div>
            <h2 className='fw-bolder'>Terminate Application</h2>                    
        </div>         
        <div
            className='btn btn-icon btn-sm btn-active-icon-primary'
            data-kt-applications-modal-action='close'
            onClick={() => setItemIdForDelete(undefined)}
            style={{cursor: 'pointer'}}
        >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
        </div>        
    </div>
    )
}

export {DLMApplicationTerminateModalHeader}
